import React, { memo, useContext } from "react";
import { isZH } from "./locale";
import { genContentByAttrs } from "./common/text";
import { ToolFnContext } from "./utils/context";
import { switchHighlightTextStrToArray } from "./utils/yach_link";
import {
  getDefaultComponentStyle,
  getDefaultTextStyle,
} from "./utils/defaultStyles";

const emptyStr = "\u2005";

export default memo(
  ({
    data,
    getText,
    isStreaming,
  }: {
    data: IMultiElementCombineMsg.ITextElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
    isStreaming: boolean;
  }) => {
    const { type, content } = data || {};
    const {
      distinguishSwitch,
      regUrl,
      textFiltering,
      textTags,
      filterText,
      marked,
    } = useContext(ToolFnContext);

    if (!content) return null;

    // 判断是否为文本组件
    const isTextComponent = type === "text";

    // 获取默认组件样式
    const componentStyle = getDefaultComponentStyle(data) as any;

    // 判断是否存在 attributes_i18n 属性来决定是否为富文本
    const isRichText = !!data.attributes_i18n;

    // 根据是否为富文本选择传递给 getDefaultTextStyle 的参数
    const textStyle = getDefaultTextStyle(isRichText ? data : data.content);

    const getTextOfLink = (text: string) => {
      const textArr = checkHasLink(text);
      const renderText = textArr ? getLinkFormat(textArr) : textFiltering(text);
      return renderText;
    };

    const checkHasLink = (textStr: string) => {
      if (distinguishSwitch && regUrl) {
        const { textArr } = switchHighlightTextStrToArray({ textStr, regUrl });
        if (
          !textArr ||
          !textArr.length ||
          !textArr.find((item) => item.isLink)
        ) {
          return;
        }
        return textArr;
      }
    };

    // 文档格式
    const getLinkFormat = (textArr: any[]) => {
      let textStr = "";
      let leftArrow = `${textTags["<"]}`;
      let rightArrow = `${textTags[">"]}`;

      for (let index = 0; index < textArr.length; index++) {
        const { isLink, text, url } = textArr[index];

        if (isLink) {
          textStr += filterText(
            `${leftArrow}span contenteditable="false" data-link="true" data-url="${url}" data-text="${text}" style="display: inline; color: #1560E7;cursor: pointer;" onclick="window.open('${url}')"${rightArrow}${leftArrow}i class="iconfont-yach yach-zaixianwendang1" style="margin-left: 2px;"${rightArrow}${leftArrow}/i${rightArrow}${text}${leftArrow}/span${rightArrow}${emptyStr}`,
            true,
            false
          );
        } else {
          textStr += filterText(text);
        }
      }
      return textStr;
    };

    const textRender = () => {
      const { attributes_i18n } = content;
      const attrs = isZH() ? attributes_i18n?.zh_cn : attributes_i18n?.en_us;

      if (!attrs || !attrs.length) {
        return (
          <div
            className={`${"sscard-textBox"} ${
              isStreaming ? "sscard-disableAction" : ""
            }`}
            style={isTextComponent ? componentStyle : {}}
          >
            <div
              style={textStyle}
              dangerouslySetInnerHTML={{
                __html: getTextOfLink(getText(content)),
              }}
            />
          </div>
        );
      } else {
        // 富文本
        return (
          <div
            className={`${"sscard-textBox"} ${
              isStreaming ? "sscard-disableAction" : ""
            }`}
            style={isTextComponent ? { ...componentStyle, ...textStyle } : {}}
          >
            {genContentByAttrs(attrs, textStyle)}
          </div>
        );
      }
    };

    return content.type == "plain_text" ? (
      textRender()
    ) : content.type == "markdown" ? (
      <div
        className={`${
          isStreaming ? "sscard-disableAction" : ""
        } sscard-markdown`}
        style={(isTextComponent && componentStyle) || null}
        dangerouslySetInnerHTML={{ __html: marked(getText(content)) || "" }}
      />
    ) : null;
  }
);
